import { Button, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Stepper from "@mui/material/Stepper";
import PhoneRoundedIcon from "@mui/icons-material/PhoneRounded";
import axios from "axios";
import Cookies from "js-cookie";
import * as React from "react";
import { useEffect, useState } from "react";
import { NavLink, Navigate, useParams } from "react-router-dom";
import AskModal from "./AskModal";
import SimpleBackdrop from "./BackDrop";
import { getResultStep, selectActiveResult } from "./resultSelection";


// const steps = [
//   "Select master blaster campaign settings",
//   "Create an ad group",
//   "Create an ad",
// ];

export default function Results({ bidId, adminView = false }) {
  const [noResult, setNoResult] = useState(false);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [open1, setOpen1] = React.useState(false);
  const handleOpen1 = () => setOpen1(true);
  const handleClose1 = () => setOpen1(false);
  const [open2, setOpen2] = React.useState(false);
  const handleBackDrop = (e) => {
    setOpen2(e);
  };
  const handleClose2 = () => {
    setOpen2(false);
  };
  const handleToggle = () => {
    setOpen(!open);
  };
  const [phoneNumber, setPhoneNumber] = useState("");
  const [professionalPhoneNumber, setProfessionalPhoneNumber] = useState("");
  const [bidEnded, setBidEnded] = useState(true);
  const { id } = useParams();
  const [result, setResult] = React.useState({});
  const [wait, setWait] = useState(false);
  const [userId, setUserId] = useState(-1);
  const [ownerAccountDeleted, setOwnerAccountDeleted] = useState(false);
  const [resultProcessClosed, setResultProcessClosed] = useState(false);
  const [resultCustomerApproved, setResultCustomerApproved] = useState(false);
  const [canViewApprovalProgress, setCanViewApprovalProgress] = useState(null);
  const [hasOffers, setHasOffers] = useState(false);
  const [selectionPhase, setSelectionPhase] = useState(null);
  const [phaseDeadlineAt, setPhaseDeadlineAt] = useState(null);
  const [remainingMs, setRemainingMs] = useState(0);
  const [step, setStep] = useState(0);
  const [loadError, setLoadError] = useState("");
  const changeStep = (e) => {
    if (e === 3) {
      console.log("Hello I am Abid it did happen!");
      let month = parseInt(new Date().getMonth()) + 1;
      axios
        .post(
          `${process.env.React_APP_BACKEND_URL}/api/postdeal`,
          {
            id: id,
            date:
              new Date().getDate() +
              "/" +
              month +
              "/" +
              new Date().getFullYear(),
          },
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("token")}`,
            },
          }
        )
        .then((res) => console.log(res))
        .catch((err) => console.log(err));
    }
    setStep(e);
  };
  useEffect(() => {
    axios
      .get(`${process.env.React_APP_BACKEND_URL}/api/${adminView ? "admin/getresult" : "getresult"}?id=${id}`, {
        headers: {
          Authorization: `Bearer ${adminView ? Cookies.get("admintoken") : Cookies.get("token")}`,
        },
      })
      .then((res) => {
        console.log(res);
        setLoadError("");
        const mayViewProgress = Boolean(res.data.CanViewApprovalProgress);
        const offersExist = Boolean(res.data.HasOffers);
        setCanViewApprovalProgress(mayViewProgress);
        setHasOffers(offersExist);
        setSelectionPhase(res.data.SelectionPhase || null);
        setPhaseDeadlineAt(res.data.PhaseDeadlineAt || null);
        const bid = Array.isArray(res.data.Bid) ? res.data.Bid[0] : null;
        const rawDeadline = bid?.deadline ?? bid?.dateDeadline ?? null;
        const parsedDeadline = rawDeadline == null
          ? NaN
          : (typeof rawDeadline === "number" || /^\d+$/.test(String(rawDeadline))
              ? Number(rawDeadline)
              : new Date(rawDeadline).getTime());
        setBidEnded(Number.isFinite(parsedDeadline) ? parsedDeadline < Date.now() : true);
        setPhoneNumber(res.data.JobAdverter);
        setProfessionalPhoneNumber(res.data.ProfessionalPhone || "");
        setOwnerAccountDeleted(Boolean(res.data.Bid?.[0]?.owner_account_deleted_at));
        if (!mayViewProgress) {
          setNoResult(!offersExist);
          setWait(false);
          setResult({});
        } else if (res.data.Result.length !== 0) {
          const requestedResult = res.data.DisplayResultId == null
            ? null
            : res.data.Result.find(
                (row) => String(row.id) === String(res.data.DisplayResultId)
              );
          const activeResult = requestedResult || selectActiveResult(res.data.Result);

          if (activeResult) {
            setNoResult(false);
            setWait(false);
            setResult(activeResult);
            const processClosed = Boolean(res.data.ApprovalProcessClosed) || Number(activeResult.major) === 3;
            setResultProcessClosed(processClosed);
            setResultCustomerApproved(activeResult.bidderaccept === "Yes");
            if (processClosed) setStep(2);
            else setStep(getResultStep(activeResult));
          } else if (res.data.HasOffers) {
            // Offers exist but their result rows are still being processed. Do not
            // incorrectly tell the user that the tender received no offers.
            setNoResult(false);
            setWait(true);
          } else {
            setWait(false);
            setNoResult(true);
          }
        } else {
          setNoResult(false);
          setWait(true);
        }

        setUserId(res.data.UserId?.user_id ?? -1);
      })
      .catch((err) => {
        console.error("Failed to load results", err);
        setLoadError("לא ניתן לטעון כרגע את תוצאות המכרז. הנתונים לא נמחקו. נסו לרענן את העמוד.");
        setWait(false);
        setCanViewApprovalProgress(null);
      });
  }, [id, step, adminView]);

  useEffect(() => {
    if (!phaseDeadlineAt) {
      setRemainingMs(0);
      return undefined;
    }

    const updateRemainingTime = () => {
      const deadline = new Date(phaseDeadlineAt).getTime();
      setRemainingMs(Number.isFinite(deadline) ? Math.max(0, deadline - Date.now()) : 0);
    };

    updateRemainingTime();
    const timer = window.setInterval(updateRemainingTime, 1000);
    return () => window.clearInterval(timer);
  }, [phaseDeadlineAt]);
  const [isReview, setIsReview] = useState(false);

  const currentUserId = Cookies.get("id") || "";
  const isWinningProfessional =
    !adminView &&
    result.bidderId !== undefined &&
    currentUserId.toString() === String(result.bidderId);
  const isJobAdverter =
    !adminView && userId !== -1 && currentUserId.toString() === userId.toString();
  const canInspectAsCustomer = adminView || isJobAdverter;
  const contactPhone = isWinningProfessional
    ? phoneNumber
    : isJobAdverter
    ? professionalPhoneNumber
    : "";
  const contactLabel = isWinningProfessional
    ? "מספר הטלפון של הלקוח"
    : isJobAdverter
    ? "מספר הטלפון של בעל המקצוע"
    : "פרטי התקשרות";
  const professionalDeclaration = (() => {
    if (!result.professional_declaration) return null;
    if (typeof result.professional_declaration === "object") {
      return result.professional_declaration;
    }
    try {
      return JSON.parse(result.professional_declaration);
    } catch (error) {
      return null;
    }
  })();
  const advanceIntentLabels = {
    no: "בעל המקצוע הצהיר שלא יבקש מקדמה.",
    possible: "בעל המקצוע הצהיר שייתכן שיבקש מקדמה.",
    yes: "בעל המקצוע הצהיר שיבקש מקדמה.",
  };
  const phaseLabels = {
    first_customer_decision: "הזמן שנותר למפרסם המכרז לבחירת ההצעה הראשונה",
    first_professional_response: "הזמן שנותר לבעל המקצוע הראשון לאישור ההצעה",
    second_customer_decision: "הזמן שנותר למפרסם המכרז לבחירת ההצעה השנייה",
    second_professional_response: "הזמן שנותר לבעל המקצוע השני לאישור ההצעה",
  };
  const inactiveTimerMessages = {
    completed: "תהליך האישורים הושלם ולכן אין כעת שעון פעיל.",
    closed: "תהליך האישורים נסגר ולכן אין כעת שעון פעיל.",
  };
  const locallyExpiredTerminalPhase =
    Boolean(phaseDeadlineAt) &&
    remainingMs === 0 &&
    ["first_customer_decision", "second_customer_decision", "second_professional_response"].includes(selectionPhase);
  const effectiveProcessClosed = resultProcessClosed || locallyExpiredTerminalPhase;
  const totalSeconds = Math.max(0, Math.floor(remainingMs / 1000));
  const countdownParts = {
    days: Math.floor(totalSeconds / 86400),
    hours: Math.floor((totalSeconds % 86400) / 3600),
    minutes: Math.floor((totalSeconds % 3600) / 60),
    seconds: totalSeconds % 60,
  };
  const countdownText = [
    countdownParts.days > 0 ? `${countdownParts.days} ימים` : null,
    `${String(countdownParts.hours).padStart(2, "0")}:${String(countdownParts.minutes).padStart(2, "0")}:${String(countdownParts.seconds).padStart(2, "0")}`,
  ].filter(Boolean).join(" ");

  if (loadError) {
    return (
      <Box dir="rtl" sx={{ maxWidth: 720, mx: "auto", mt: { xs: 3, md: 6 }, px: 2 }}>
        <Box sx={{ p: { xs: 2.5, md: 3.5 }, borderRadius: "20px", backgroundColor: "#FFF4E5", border: "1px solid #FFD59A", textAlign: "center" }}>
          <Typography sx={{ fontFamily: `${process.env.REACT_APP_FONT}`, fontSize: { xs: "1.1rem", md: "1.3rem" }, fontWeight: 900, color: "#8A4B08" }}>
            {loadError}
          </Typography>
          <Button onClick={() => window.location.reload()} variant="contained" sx={{ mt: 2, fontFamily: `${process.env.REACT_APP_FONT}`, borderRadius: "12px", fontWeight: 800, textTransform: "none" }}>
            רענון התוצאות
          </Button>
        </Box>
      </Box>
    );
  }

  if (ownerAccountDeleted) {
    return (
      <Box dir="rtl" sx={{ maxWidth: 720, mx: "auto", mt: { xs: 3, md: 6 }, px: 2 }}>
        <Box sx={{ p: { xs: 2.5, md: 3.5 }, borderRadius: "20px", backgroundColor: "#FFF4E5", border: "1px solid #FFD59A", textAlign: "center" }}>
          <Typography sx={{ fontFamily: `${process.env.REACT_APP_FONT}`, fontSize: { xs: "1.25rem", md: "1.5rem" }, fontWeight: 900, color: "#8A4B08" }}>
            החשבון של מפרסם המכרז אינו פעיל עוד
          </Typography>
          <Typography sx={{ fontFamily: `${process.env.REACT_APP_FONT}`, color: "#71583B", mt: 1, lineHeight: 1.7 }}>
            המכרז נסגר ולא ניתן להמשיך בתהליך האישורים או לבצע בו פעולות נוספות.
          </Typography>
          <Button component={NavLink} to="/" variant="contained" sx={{ mt: 2, fontFamily: `${process.env.REACT_APP_FONT}`, borderRadius: "12px", fontWeight: 800, textTransform: "none" }}>
            חזרה לדף הבית
          </Button>
        </Box>
      </Box>
    );
  }

  const contactDetails = (mobile = false) => (
    <Box
      dir="rtl"
      sx={{
        width: "100%",
        maxWidth: mobile ? "100%" : 230,
        minWidth: 0,
        mx: "auto",
        boxSizing: "border-box",
      }}
    >
      <Typography
        sx={{
          mb: 0.65,
          color: step === 3 ? "#4E6579" : "#7E8F9F",
          fontFamily: `${process.env.REACT_APP_FONT}`,
          fontWeight: 700,
          fontSize: mobile ? "0.9rem" : "0.84rem",
          textAlign: "center",
          lineHeight: 1.35,
        }}
      >
        {step === 3 ? contactLabel : "פרטי ההתקשרות יופיעו לאחר אישור שני הצדדים"}
      </Typography>
      <Typography
        sx={{
          fontFamily: "Assistant",
          fontWeight: 800,
          fontSize: mobile ? "1.15rem" : "1.05rem",
          color: step === 3 ? "#153A5B" : "#94A6B8",
          backgroundColor: step === 3 ? "#EEF7FF" : "#F5F7FA",
          border: "1px solid",
          borderColor: step === 3 ? "#CDE7FF" : "#E7ECF2",
          borderRadius: "12px",
          px: 1.4,
          py: 0.75,
          textAlign: "center",
          direction: "ltr",
          letterSpacing: step === 3 ? "0.02em" : "0.1em",
          overflowWrap: "anywhere",
          boxSizing: "border-box",
        }}
      >
        {step === 3 && contactPhone ? contactPhone : "*********"}
      </Typography>
      {step === 3 && contactPhone && (
        <Button
          component="a"
          href={`tel:${contactPhone.replace(/[^\d+]/g, "")}`}
          startIcon={<PhoneRoundedIcon />}
          fullWidth
          variant="contained"
          sx={{
            mt: 0.9,
            minHeight: 42,
            borderRadius: "12px",
            fontFamily: `${process.env.REACT_APP_FONT}`,
            fontWeight: 800,
            fontSize: mobile ? "1rem" : "0.92rem",
            textTransform: "none",
            boxShadow: "none",
            background: "linear-gradient(135deg, #18885C 0%, #35B77A 100%)",
            "&:hover": {
              background: "linear-gradient(135deg, #14734E 0%, #2FA36D 100%)",
              boxShadow: "0 6px 14px rgba(24,136,92,.20)",
            },
            "& .MuiButton-startIcon": {
              ml: 0.7,
              mr: 0,
            },
          }}
        >
          התקשרות
        </Button>
      )}
    </Box>
  );

  return (
    <Box
      className="bidit-results-process"
      sx={{
        fontFamily: `${process.env.REACT_APP_FONT}`,
        width: "100%",
        maxWidth: "1180px",
        margin: { xs: "14px auto 32px", md: "28px auto 48px" },
        px: { xs: 1.5, sm: 2.5 },
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        boxSizing: "border-box",
        overflowX: "hidden",
      }}
      dir="ltr"
    >
      {adminView && canViewApprovalProgress && (
        <Box
          dir="rtl"
          sx={{
            alignSelf: "flex-start",
            mb: 1.5,
            px: 1.5,
            py: 0.7,
            borderRadius: "999px",
            color: "#154B73",
            backgroundColor: "#E8F4FF",
            border: "1px solid #B9DCF7",
            fontFamily: `${process.env.REACT_APP_FONT}`,
            fontWeight: 800,
            fontSize: "0.88rem",
          }}
        >
          תצוגת אדמין - פירוט תהליך האישור
        </Box>
      )}
      {canViewApprovalProgress && (
        <Box
          dir="rtl"
          sx={{
            width: "100%",
            maxWidth: 760,
            mb: 2,
            p: { xs: 1.8, sm: 2.2 },
            borderRadius: "18px",
            border: "1px solid #D8E7F4",
            backgroundColor: "#F8FBFE",
            boxSizing: "border-box",
          }}
        >
          <Typography sx={{ fontFamily: `${process.env.REACT_APP_FONT}`, color: "#173F5F", fontWeight: 900, fontSize: { xs: "1rem", sm: "1.08rem" } }}>
            לוח הזמנים של תהליך האישורים
          </Typography>
          <Typography sx={{ mt: 0.65, fontFamily: `${process.env.REACT_APP_FONT}`, color: "#526B7F", lineHeight: 1.7, fontSize: { xs: "0.9rem", sm: "0.96rem" } }}>
            48 שעות לבחירת הלקוח, 24 שעות לתשובת בעל המקצוע הראשון, ואם עוברים להצעה השנייה - 48 שעות נוספות לבחירת הלקוח ו-24 שעות לתשובת בעל המקצוע השני.
          </Typography>
          {!phaseDeadlineAt && (
            <Typography sx={{ mt: 0.8, fontFamily: `${process.env.REACT_APP_FONT}`, color: "#80571B", fontWeight: 700, fontSize: "0.88rem" }}>
              {inactiveTimerMessages[selectionPhase] ||
                (selectionPhase === "closed" && !resultCustomerApproved
                  ? "חלון האישור הסתיים מבלי שהלקוח אישר את ההצעה."
                  : wait
                  ? "המערכת מעבדת כעת את התוצאות. השעון יופיע מיד עם פתיחת השלב הפעיל."
                  : !resultCustomerApproved
                  ? "הלקוח עדיין לא אישר את ההצעה. אם חלון האישור פעיל, השעון יוצג כאן."
                  : "לא מוגדר כרגע חלון זמן פעיל למכרז זה.")}
            </Typography>
          )}
        </Box>
      )}
      {canViewApprovalProgress === false && hasOffers && (
        <Box
          dir="rtl"
          sx={{
            width: "100%",
            maxWidth: 720,
            mx: "auto",
            p: { xs: 2.4, sm: 3.2 },
            borderRadius: "20px",
            border: "1px solid #B9DCF7",
            background: "linear-gradient(135deg, #FFFFFF 0%, #EAF6FF 58%, #FFF7E8 100%)",
            boxShadow: "0 14px 34px rgba(31,103,164,.12)",
            textAlign: "center",
            boxSizing: "border-box",
          }}
        >
          <Box
            aria-hidden="true"
            sx={{
              width: 52,
              height: 52,
              mx: "auto",
              mb: 1.3,
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#FFFFFF",
              boxShadow: "0 7px 18px rgba(31,103,164,.14)",
              fontSize: "1.55rem",
            }}
          >
            🎉
          </Box>
          <Typography sx={{ fontFamily: `${process.env.REACT_APP_FONT}`, color: "#173F5F", fontWeight: 900, fontSize: { xs: "1.08rem", sm: "1.25rem" } }}>
            המכרז הסתיים עם הצעות מחיר
          </Typography>
          <Typography sx={{ mt: 1, fontFamily: `${process.env.REACT_APP_FONT}`, color: "#526B7F", lineHeight: 1.7 }}>
            המכרז קיבל הצעות, וכעת תהליך הבחירה והאישור ממשיך בין מפרסם המכרז לבעל המקצוע הרלוונטי.
          </Typography>
          <Button
            component={NavLink}
            to="/home"
            variant="contained"
            sx={{
              mt: 2,
              px: 3,
              py: 0.9,
              borderRadius: "999px",
              fontFamily: `${process.env.REACT_APP_FONT}`,
              fontWeight: 800,
              textTransform: "none",
              boxShadow: "0 8px 18px rgba(35,139,235,.22)",
            }}
          >
            לצפייה במכרזים נוספים
          </Button>
        </Box>
      )}
      {canViewApprovalProgress && phaseDeadlineAt && phaseLabels[selectionPhase] && !locallyExpiredTerminalPhase && (
        <Box
          dir="rtl"
          role="timer"
          aria-live="polite"
          sx={{
            width: "100%",
            maxWidth: 680,
            mb: 2,
            p: { xs: 1.7, sm: 2.1 },
            borderRadius: "18px",
            background: "linear-gradient(135deg, #173F5F 0%, #2479B8 100%)",
            color: "#fff",
            textAlign: "center",
            boxShadow: "0 12px 28px rgba(23,63,95,.18)",
            boxSizing: "border-box",
          }}
        >
          <Typography sx={{ fontFamily: `${process.env.REACT_APP_FONT}`, fontWeight: 800, fontSize: { xs: "0.92rem", sm: "1rem" }, opacity: 0.92 }}>
            {phaseLabels[selectionPhase]}
          </Typography>
          <Typography sx={{ mt: 0.4, fontFamily: `${process.env.REACT_APP_FONT}`, fontWeight: 900, fontSize: { xs: "1.65rem", sm: "2rem" }, direction: "ltr" }}>
            {remainingMs > 0 ? countdownText : "הזמן הסתיים"}
          </Typography>
        </Box>
      )}
      {canViewApprovalProgress && userId !== -1 && bidEnded && !wait && !noResult && (
        <Box
          sx={{
            fontFamily: `${process.env.REACT_APP_FONT}`,
            width: "100%",
            backgroundColor: "#fff",
            border: "1px solid #E8EEF5",
            borderRadius: { xs: "18px", md: "24px" },
            boxShadow: "0 14px 38px rgba(28, 73, 120, 0.10)",
            px: { xs: 1.5, sm: 3, md: 4 },
            py: { xs: 2.5, md: 4 },
            boxSizing: "border-box",
            overflowX: "hidden",
          }}
        >
          {effectiveProcessClosed && (
            <Box
              dir="rtl"
              sx={{
                mb: 2.5,
                mx: "auto",
                maxWidth: "620px",
                p: 1.5,
                borderRadius: "12px",
                backgroundColor: "#FFF4E5",
                border: "1px solid #FFD59A",
                color: "#8A4B08",
                textAlign: "center",
                fontWeight: 800,
              }}
            >
              תהליך האישור במכרז הסתיים. התוצאה מוצגת לצפייה בלבד.
            </Box>
          )}
          {/* תצוגת שלבים בדסקטופ */}
          <Stepper
            activeStep={effectiveProcessClosed ? -1 : step}
            alternativeLabel
            sx={{
              display: { xs: "none", md: "flex" },
              fontFamily: `${process.env.REACT_APP_FONT}`,
              width: "100%",
              direction: "ltr",
              overflow: "visible",
              "& .MuiStep-root": {
                px: 1,
                position: "relative",
              },
              "& .MuiStepLabel-root": {
                position: "relative",
                zIndex: 1,
              },
              "& .MuiStepLabel-iconContainer": {
                position: "relative",
                zIndex: 2,
                backgroundColor: "#fff",
                borderRadius: "50%",
                px: 0.75,
              },
              "& .MuiStepLabel-labelContainer": {
                mt: 1.25,
                textAlign: "center",
              },
              "& .MuiStepConnector-root": {
                top: 18,
                left: "calc(-50% + 28px)",
                right: "calc(50% + 28px)",
                zIndex: 0,
              },
              "& .MuiStepConnector-line": {
                borderColor: "#D7E0E9",
                borderTopWidth: 2,
                borderRadius: 8,
              },
              "& .MuiStepConnector-root.Mui-active .MuiStepConnector-line, & .MuiStepConnector-root.Mui-completed .MuiStepConnector-line": {
                borderColor: "#35B77A",
              },
              "& .MuiStepIcon-root": {
                color: "#DCE8F5",
                fontSize: 36,
              },
              "& .MuiStepIcon-root.Mui-active": {
                color: "#238BEB",
                filter: "drop-shadow(0 4px 8px rgba(35,139,235,.20))",
              },
              "& .MuiStepIcon-root.Mui-completed": {
                color: "#35B77A",
              },
            }}
          >
            <Step>
              <StepLabel dir="rtl">
                {effectiveProcessClosed ? (
                  <Typography
                    dir="rtl"
                    sx={{
                      fontFamily: `${process.env.REACT_APP_FONT}`,
                      color: "#8A4B08",
                      fontWeight: 800,
                      fontSize: "0.95rem",
                    }}
                  >
                    {resultCustomerApproved
                      ? "הלקוח אישר, אך התהליך נסגר ללא אישור בעל המקצוע"
                      : "לא בוצע אישור לקוח"}
                  </Typography>
                ) : step === 0 ? (
                  <Button
                    sx={{
                      fontFamily: `${process.env.REACT_APP_FONT}`,
                      fontWeight: 700,
                      borderRadius: "12px",
                      px: 2.5,
                      py: 1,
                      textTransform: "none",
                      boxShadow: "none",
                      "&:not(.Mui-disabled)": {
                        background: "linear-gradient(135deg, #238BEB 0%, #3EA7FF 100%)",
                        boxShadow: "0 7px 16px rgba(35,139,235,.22)",
                      },
                    }}
                    variant={
                      !effectiveProcessClosed &&
                      isJobAdverter
                        ? "contained"
                        : "disabled"
                    }
                    onClick={handleOpen}
                  >
                    מפרסם המכרז - לחץ כאן​
                  </Button>
                ) : (
                  <Box sx={{ textAlign: "center" }}>
                    <Typography
                      dir="rtl"
                      sx={{
                        fontFamily: `${process.env.REACT_APP_FONT}`,
                        color: "#18885C",
                        fontWeight: 800,
                        fontSize: "1rem",
                        backgroundColor: "#ECFAF4",
                        border: "1px solid #CBEFDF",
                        borderRadius: "12px",
                        px: 1.5,
                        py: 0.8,
                        display: "inline-block",
                      }}
                    >
                      ההצעה התקבלה על ידי הלקוח​
                    </Typography>
                    {step === 1 &&
                      canInspectAsCustomer && (
                        <Typography
                          dir="rtl"
                          sx={{
                            mt: 0.6,
                            color: "#667085",
                            fontFamily: `${process.env.REACT_APP_FONT}`,
                            fontSize: "0.78rem",
                            fontWeight: 600,
                          }}
                        >
                          ממתינים לאישור על ידי בעל המקצוע
                        </Typography>
                      )}
                  </Box>
                )}
              </StepLabel>
            </Step>

            <Step>
              <StepLabel dir="rtl">
                <Button
                  sx={{
                    fontFamily: `${process.env.REACT_APP_FONT}`,
                    fontWeight: 700,
                    borderRadius: "12px",
                    px: 2.5,
                    py: 1,
                    textTransform: "none",
                    boxShadow: "none",
                    "&:not(.Mui-disabled)": {
                      background: "linear-gradient(135deg, #FA9B28 0%, #FFB64C 100%)",
                      boxShadow: "0 7px 16px rgba(250,155,40,.22)",
                    },
                  }}
                  variant={
                    !effectiveProcessClosed &&
                    isWinningProfessional &&
                    step === 1
                      ? "contained"
                      : "disabled"
                  }
                  onClick={handleOpen1}
                >
                  {effectiveProcessClosed
                    ? resultCustomerApproved
                      ? "לא התקבל אישור בעל המקצוע בזמן"
                      : "לא נדרש אישור בעל מקצוע"
                    : "בעל המקצוע - לחץ כאן"}
                </Button>
              </StepLabel>
            </Step>

            <Step>
              <StepLabel dir="rtl">
                {contactDetails(false)}
              </StepLabel>
            </Step>

            <Step>
              <StepLabel dir="rtl">
                {result.review === "no" ? (
                  <Button
                    sx={{
                      fontFamily: `${process.env.REACT_APP_FONT}`,
                      fontWeight: 700,
                      borderRadius: "12px",
                      px: 2,
                      py: 1,
                      textTransform: "none",
                      "&:not(.Mui-disabled)": {
                        background: "linear-gradient(135deg, #238BEB 0%, #3EA7FF 100%)",
                        boxShadow: "0 7px 16px rgba(35,139,235,.22)",
                      },
                    }}
                    variant={
                      !effectiveProcessClosed &&
                      isJobAdverter &&
                      result.proaccept !== null &&
                      step === 3
                        ? "contained"
                        : "disabled"
                    }
                    onClick={(e) => setIsReview(true)}
                  >
                    מפרסם המכרז - מלא חוות דעת​
                  </Button>
                ) : (
                  <Typography
                    dir="rtl"
                    sx={{
                      fontFamily: `${process.env.REACT_APP_FONT}`,
                      color: "#18885C",
                      fontWeight: 800,
                      fontSize: "1rem",
                      backgroundColor: "#ECFAF4",
                      border: "1px solid #CBEFDF",
                      borderRadius: "12px",
                      px: 1.5,
                      py: 0.8,
                      display: "inline-block",
                    }}
                  >
                    ניתנה ביקורת
                  </Typography>
                )}
              </StepLabel>
            </Step>
          </Stepper>

          {/* תצוגת שלבים במובייל - כרטיסים אנכיים ללא גלילה אופקית */}
          <Box
            dir="rtl"
            sx={{
              display: { xs: "flex", md: "none" },
              flexDirection: "column",
              gap: 1.25,
              width: "100%",
              maxWidth: "100%",
              minWidth: 0,
              overflowX: "hidden",
              boxSizing: "border-box",
            }}
          >
            {[
              {
                number: 1,
                completed: !effectiveProcessClosed && step > 0,
                content:
                  effectiveProcessClosed ? (
                    <Typography
                      sx={{
                        color: "#8A4B08",
                        fontWeight: 800,
                        fontFamily: `${process.env.REACT_APP_FONT}`,
                        textAlign: "center",
                      }}
                    >
                      {resultCustomerApproved
                        ? "הלקוח אישר, אך התהליך נסגר ללא אישור בעל המקצוע"
                        : "לא בוצע אישור לקוח"}
                    </Typography>
                  ) : step === 0 ? (
                    <Button
                      sx={{
                        width: "100%",
                        minWidth: 0,
                        fontFamily: `${process.env.REACT_APP_FONT}`,
                        fontWeight: 700,
                        borderRadius: "12px",
                        py: 1,
                        textTransform: "none",
                        whiteSpace: "normal",
                        lineHeight: 1.4,
                        "&:not(.Mui-disabled)": {
                          background: "linear-gradient(135deg, #238BEB 0%, #3EA7FF 100%)",
                        },
                      }}
                      variant={
                        !effectiveProcessClosed &&
                        isJobAdverter
                          ? "contained"
                          : "disabled"
                      }
                      onClick={handleOpen}
                    >
                      מפרסם המכרז - לחץ כאן
                    </Button>
                  ) : (
                    <Box sx={{ textAlign: "center", width: "100%" }}>
                      <Typography
                        sx={{
                          color: "#18885C",
                          fontWeight: 800,
                          fontFamily: `${process.env.REACT_APP_FONT}`,
                          backgroundColor: "#ECFAF4",
                          border: "1px solid #CBEFDF",
                          borderRadius: "12px",
                          px: 1.25,
                          py: 0.8,
                          textAlign: "center",
                          overflowWrap: "anywhere",
                        }}
                      >
                        ההצעה התקבלה על ידי הלקוח
                      </Typography>
                      {step === 1 &&
                        canInspectAsCustomer && (
                          <Typography
                            sx={{
                              mt: 0.6,
                              color: "#667085",
                              fontFamily: `${process.env.REACT_APP_FONT}`,
                              fontSize: "0.78rem",
                              fontWeight: 600,
                            }}
                          >
                            ממתינים לאישור על ידי בעל המקצוע
                          </Typography>
                        )}
                    </Box>
                  ),
              },
              {
                number: 2,
                completed: !effectiveProcessClosed && step > 1,
                content: (
                  <Button
                    sx={{
                      width: "100%",
                      minWidth: 0,
                      fontFamily: `${process.env.REACT_APP_FONT}`,
                      fontWeight: 700,
                      borderRadius: "12px",
                      py: 1,
                      textTransform: "none",
                      whiteSpace: "normal",
                      lineHeight: 1.4,
                      "&:not(.Mui-disabled)": {
                        background: "linear-gradient(135deg, #FA9B28 0%, #FFB64C 100%)",
                      },
                    }}
                    variant={
                      !effectiveProcessClosed &&
                      isWinningProfessional &&
                      step === 1
                        ? "contained"
                        : "disabled"
                    }
                    onClick={handleOpen1}
                  >
                    {effectiveProcessClosed
                      ? resultCustomerApproved
                        ? "לא התקבל אישור בעל המקצוע בזמן"
                        : "לא נדרש אישור בעל מקצוע"
                      : "בעל המקצוע - לחץ כאן"}
                  </Button>
                ),
              },
              {
                number: 3,
                completed: !effectiveProcessClosed && step === 3,
                content: contactDetails(true),
              },
              {
                number: 4,
                completed: result.review !== "no",
                content:
                  result.review === "no" ? (
                    <Box sx={{ width: "100%", minWidth: 0 }}>
                      <Typography
                        sx={{
                          mb: 0.8,
                          color: "#5E7287",
                          fontWeight: 700,
                          fontSize: "0.86rem",
                          textAlign: "center",
                          fontFamily: `${process.env.REACT_APP_FONT}`,
                        }}
                      >
                        {step === 3
                          ? "תורך לתת חוות דעת"
                          : effectiveProcessClosed
                          ? "לא ניתן לתת חוות דעת משום שלא אושרה עסקה"
                          : "חוות הדעת תיפתח לאחר אישור שני הצדדים"}
                      </Typography>
                      <Button
                        sx={{
                          width: "100%",
                          minWidth: 0,
                          fontFamily: `${process.env.REACT_APP_FONT}`,
                          fontWeight: 700,
                          borderRadius: "12px",
                          py: 1,
                          textTransform: "none",
                          whiteSpace: "normal",
                          lineHeight: 1.4,
                          "&:not(.Mui-disabled)": {
                            background: "linear-gradient(135deg, #238BEB 0%, #3EA7FF 100%)",
                          },
                        }}
                        variant={
                          !effectiveProcessClosed &&
                          isJobAdverter &&
                          result.proaccept !== null &&
                          step === 3
                            ? "contained"
                            : "disabled"
                        }
                        onClick={(e) => setIsReview(true)}
                      >
                        מפרסם המכרז - מלא חוות דעת
                      </Button>
                    </Box>
                  ) : (
                    <Typography
                      sx={{
                        color: "#18885C",
                        fontWeight: 800,
                        fontFamily: `${process.env.REACT_APP_FONT}`,
                        backgroundColor: "#ECFAF4",
                        border: "1px solid #CBEFDF",
                        borderRadius: "12px",
                        px: 1.25,
                        py: 0.8,
                        textAlign: "center",
                      }}
                    >
                      ניתנה ביקורת
                    </Typography>
                  ),
              },
            ].map((item) => (
              <Box
                key={item.number}
                sx={{
                  width: "100%",
                  maxWidth: "100%",
                  minWidth: 0,
                  boxSizing: "border-box",
                  display: "grid",
                  gridTemplateColumns: "42px minmax(0, 1fr)",
                  alignItems: "center",
                  gap: 1.25,
                  backgroundColor: "#F8FBFF",
                  border: "1px solid #E2EBF5",
                  borderRadius: "16px",
                  px: 1.25,
                  py: 1.25,
                  overflow: "hidden",
                }}
              >
                <Box
                  sx={{
                    width: 34,
                    height: 34,
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                    backgroundColor: item.completed ? "#35B77A" : "#238BEB",
                    color: "#fff",
                    fontWeight: 800,
                    fontSize: item.completed ? "1.2rem" : "1rem",
                    boxShadow: item.completed
                      ? "0 5px 12px rgba(53,183,122,.20)"
                      : "0 5px 12px rgba(35,139,235,.20)",
                  }}
                >
                  {item.completed ? "✓" : item.number}
                </Box>
                <Box sx={{ minWidth: 0, width: "100%" }}>{item.content}</Box>
              </Box>
            ))}
          </Box>
        </Box>
      )}
      {canViewApprovalProgress && canInspectAsCustomer && step === 3 && professionalDeclaration && (
        <Box
          dir="rtl"
          sx={{
            width: "100%",
            maxWidth: 760,
            mt: { xs: 1.5, md: 2.2 },
            mx: "auto",
            p: { xs: 2, sm: 2.6 },
            borderRadius: "18px",
            border: "1px solid #CDE7FF",
            background: "linear-gradient(135deg, #FFFFFF 0%, #F3F9FF 100%)",
            boxShadow: "0 10px 28px rgba(31,103,164,.08)",
            boxSizing: "border-box",
          }}
        >
          <Typography sx={{ fontFamily: `${process.env.REACT_APP_FONT}`, fontWeight: 900, color: "#173F5F", fontSize: { xs: "1.05rem", sm: "1.18rem" }, mb: 0.8 }}>
            הצהרת בעל המקצוע
          </Typography>
          <Typography sx={{ fontFamily: `${process.env.REACT_APP_FONT}`, fontWeight: 800, color: "#245E85", backgroundColor: "#EAF5FF", borderRadius: "12px", px: 1.5, py: 1.1, lineHeight: 1.55 }}>
            {advanceIntentLabels[professionalDeclaration.advance_intent] || "לא נמסרה תשובה בנוגע לתשלום מראש."}
          </Typography>
          <Typography sx={{ mt: 1.2, fontFamily: `${process.env.REACT_APP_FONT}`, color: "#526B7F", lineHeight: 1.65, fontSize: "0.93rem" }}>
            זו הצהרה שמסר בעל המקצוע. Bidit לא אימתה אותה ואינה מאשרת העברת תשלום.
          </Typography>
          {["possible", "yes"].includes(professionalDeclaration.advance_intent) && (
            <Box sx={{ mt: 1.3, px: 1.5, py: 1.2, borderRadius: "12px", backgroundColor: "#FFF1F0", border: "1px solid #F3C4C0" }}>
              <Typography sx={{ fontFamily: `${process.env.REACT_APP_FONT}`, color: "#8A2D25", fontWeight: 800, lineHeight: 1.6, fontSize: "0.91rem" }}>
                בקשת מקדמה אינה הופכת את התשלום לבטוח או מאושר על ידי Bidit.
              </Typography>
            </Box>
          )}
          <Typography sx={{ mt: 1.2, fontFamily: `${process.env.REACT_APP_FONT}`, color: "#526B7F", lineHeight: 1.65, fontSize: "0.93rem" }}>
            בעל המקצוע התחייב למסור מסמך תשלום מתאים עבור כל תשלום שיקבל.
          </Typography>
          <Box sx={{ mt: 1.3, px: 1.5, py: 1.2, borderRadius: "12px", backgroundColor: "#FFF7E8", border: "1px solid #F5D9A5" }}>
            <Typography sx={{ fontFamily: `${process.env.REACT_APP_FONT}`, color: "#80571B", fontWeight: 700, lineHeight: 1.6, fontSize: "0.91rem" }}>
              לפני תשלום מקדמה, ודאו למי משלמים, מה מטרת התשלום וקבלו את הסיכום בכתב.
            </Typography>
          </Box>
        </Box>
      )}
      {canViewApprovalProgress && userId !== -1 && !bidEnded && (
        <Box
          dir="rtl"
          sx={{
            width: "100%",
            maxWidth: "760px",
            mx: "auto",
            backgroundColor: "#FFF8E9",
            border: "1px solid #F6D99D",
            borderRadius: "18px",
            boxShadow: "0 12px 30px rgba(154,111,31,.08)",
            px: { xs: 2, md: 3 },
            py: { xs: 2.2, md: 3 },
          }}
        >
          <Typography
            variant="h6"
            sx={{ fontFamily: `${process.env.REACT_APP_FONT}` }}
          >
            סיום המכרז נקלט. המערכת מסדרת כעת את ההצעות ומכינה את שלב הבחירה. אין צורך לבצע פעולה כרגע, ובתוך מספר דקות מסך האישורים יתעדכן.{" "}
			<NavLink to="/home"> חזור </NavLink>
          </Typography>
        </Box>
      )}
      {canViewApprovalProgress && wait && (
        <Box
          sx={{
            fontFamily: `${process.env.REACT_APP_FONT}`,
            width: "100%",
            maxWidth: "760px",
            mx: "auto",
            backgroundColor: "#EEF7FF",
            border: "1px solid #CDE7FF",
            borderRadius: "18px",
            boxShadow: "0 12px 30px rgba(31,103,164,.08)",
            px: { xs: 2, md: 3 },
            py: { xs: 2.2, md: 3 },
          }}
        >
          <Typography
            variant="h6"
            sx={{ 
				fontFamily: `${process.env.REACT_APP_FONT}`,
                textAlign: "right",
                color: "#244C70",
                fontWeight: 700,
                lineHeight: 1.7,
                fontSize: { xs: "1rem", md: "1.1rem" },
                "& a": { color: "#1976D2", fontWeight: 800, mr: 0.5 },
			}}
          >
            סיום המכרז נקלט. המערכת מסדרת כעת את ההצעות ומכינה את שלב הבחירה. אין צורך לבצע פעולה כרגע, ובתוך מספר דקות מסך האישורים יתעדכן. 
            <NavLink to="/home"> חזור </NavLink>
          </Typography>
        </Box>
      )}
      {canViewApprovalProgress !== null && noResult && (
        <Box
          sx={{
            fontFamily: `${process.env.REACT_APP_FONT}`,
            width: "100%",
            maxWidth: "620px",
            mx: "auto",
            textAlign: "center",
            backgroundColor: "#FFFFFF",
            border: "1px solid #E6EDF2",
            borderRadius: "20px",
            boxShadow: "0 10px 28px rgba(21,63,93,.07)",
            px: { xs: 2.2, md: 3.5 },
            py: { xs: 2.8, md: 3.5 },
          }}
        >
          <Box
            sx={{
              width: 48,
              height: 48,
              borderRadius: "50%",
              mx: "auto",
              mb: 1.5,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "rgba(25,118,210,0.08)",
              color: "#1976D2",
              fontSize: "1.35rem",
            }}
          >
            ✓
          </Box>

          <Typography
            sx={{
              fontFamily: `${process.env.REACT_APP_FONT}`,
              color: "#153F5D",
              fontWeight: 800,
              fontSize: { xs: "1.1rem", md: "1.25rem" },
              lineHeight: 1.35,
            }}
          >
            המכרז הסתיים ללא הצעות
          </Typography>

          <Typography
            sx={{
              mt: 0.8,
              mb: 2.2,
              fontFamily: `${process.env.REACT_APP_FONT}`,
              color: "#6C8290",
              fontSize: { xs: "0.9rem", md: "0.96rem" },
              lineHeight: 1.65,
            }}
          >
            לא התקבלה הצעה הפעם. אפשר לחזור לעמוד הראשי ולפרסם מכרז חדש בכל רגע.
          </Typography>

          <NavLink to="/home" style={{ textDecoration: "none" }}>
            <Button
              variant="contained"
              sx={{
                minHeight: 40,
                px: 2.5,
                borderRadius: "999px",
                fontFamily: `${process.env.REACT_APP_FONT}`,
                fontWeight: 700,
                fontSize: "0.9rem",
                textTransform: "none",
                background: "linear-gradient(135deg, #F59A23, #FF870A)",
                boxShadow: "0 4px 12px rgba(245,154,35,0.20)",
                "&:hover": {
                  background: "linear-gradient(135deg, #ED901C, #F77D00)",
                  boxShadow: "0 6px 15px rgba(245,154,35,0.26)",
                  transform: "translateY(-1px)",
                },
                transition: "all .18s ease",
              }}
            >
              חזרה לעמוד הראשי
            </Button>
          </NavLink>
        </Box>
      )}
      {open && (
        <AskModal
          open={open}
          setOpen2={handleBackDrop}
          id={id}
          handleOpen={handleOpen}
          handleClose={handleClose}
          mes={"Offer Accept"}
          result={result}
          changeStep={changeStep}
        />
      )}
      {open1 && (
        <AskModal
          open={open1}
          id={id}
          setOpen2={handleBackDrop}
          handleOpen={handleOpen1}
          handleClose={handleClose1}
          mes={"Job Accept"}
          result={result}
          changeStep={changeStep}
        />
      )}
      {open2 && (
        <SimpleBackdrop
          open={open2}
          setOpen={setOpen2}
          handleClose={handleClose2}
          handleToogle={handleToggle}
        />
      )}
      {isReview && <Navigate to={`/review/${id}`}></Navigate>}
    </Box>
  );
}
